module.exports = __webpack_public_path__ + "static/img/LOGONAME.241d605.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/print/LOGONAME.png
// module id = J+xJ
// module chunks = 1